import React from 'react';
import ProposalCheckbox from './ProposalCheckbox';

const proposalCheckboxConfig = {
  label: 'Cases à cocher',
  defaultProps: { question: '', options: [], checkboxStyleId: null, checkboxStyles: [] },
  fields: {
    question: { type: 'text', label: 'Question' },
  },
  render: ({ id, question, options, checkboxStyleId, checkboxStyles }) => (
    <ProposalCheckbox
      id={id}
      question={question}
      options={options}
      checkboxStyleId={checkboxStyleId}
      checkboxStyles={checkboxStyles}
    />
  ),
};

export default proposalCheckboxConfig;
